import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup } from 'reactstrap';
import { Button } from 'components/Button';

export const LOWER_LTV_ACTIONS = {
  PAYMENT: 'payment',
  COLLATERAL: 'collateral',
};

const PaymentActionToggle = ({ activeAction, onChange }) => (
  <ButtonGroup
    size="sm"
    className="d-flex lower-ltv-modal__action-toggle"
    role="tablist"
    aria-label="Lower LTV action"
  >
    <Button
      color="primary"
      role="tab"
      aria-selected={activeAction === LOWER_LTV_ACTIONS.COLLATERAL}
      active={activeAction === LOWER_LTV_ACTIONS.COLLATERAL}
      onClick={() => onChange(LOWER_LTV_ACTIONS.COLLATERAL)}
    >
      Deposit Collateral
    </Button>
    <Button
      color="primary"
      role="tab"
      aria-selected={activeAction === LOWER_LTV_ACTIONS.PAYMENT}
      active={activeAction === LOWER_LTV_ACTIONS.PAYMENT}
      onClick={() => onChange(LOWER_LTV_ACTIONS.PAYMENT)}
    >
      Make Extra Payment
    </Button>
  </ButtonGroup>
);

PaymentActionToggle.propTypes = {
  activeAction: PropTypes.oneOf([LOWER_LTV_ACTIONS.PAYMENT, LOWER_LTV_ACTIONS.COLLATERAL]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PaymentActionToggle;
